import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

import Modal from 'components/Modals/presets/BasicModal';

export const CannotChangeBillingCadenceDialog = (props: any) => {
  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      heading={t('Cannot Change Billing Cycle')}
      buttonText={t('Close')}
      leftBtn={null}
      actionBtnColor={'blue'}
    >
      <div className="pb-2">
        <Typography>
          {t(
            'The billing cycle can only be changed for a business with a paid plan. Please select a paid plan before switching to annual billing.'
          )}
        </Typography>
      </div>
    </Modal>
  );
};
